import * as React from 'react'
import * as api from '../instantAuditsAdminApi'
import moment from 'moment'
import Select from "react-select";
import {chunk, cloneDeep, range} from "lodash";
import * as axios from "axios";
import SessionStore from "../../../../services/session/SessionStore";
import {Pagination} from "../../../../components/pagination/Pagination";
import './instantAuditsUsage.scss'
import HelpIcon from "../../../../components/helpicon/HelpIcon";
import reactSelectStyles from '../../../../services/config/reactSelect/reactSelectStyles';
import reactSelectTheme from '../../../../services/config/reactSelect/reactSelectTheme';
import {IndicatorsContainer,DropdownIndicator,IndicatorSeparator} from '../../../../services/config/reactSelect/components';
import UsePageTitle from '../../../app/layout/UsePageTitle';
import PageTitle from '../../../../components/typography/PageTitle';

const defaultSortOrder = 'DESC'

const dateRanges = [
  {
    label: "Last 1 Day",
    value: moment().subtract(1,'days')
  },
  {
    label: "Last 7 Days",
    value: moment().subtract(7,'days')
  },
  {
    label: "Last 30 Days",
    value: moment().subtract(30,'days')
  },
  {
    label: "Last 3 Months",
    value: moment().subtract(3,'months')
  },
  {
    label: "Last 6 Months",
    value: moment().subtract(6,'months')
  },
  {
    label: "Last 12 Months",
    value: moment().subtract(12,'months')
  }
];

const placesArray = (places) => {
  const keys = Object.keys(places)
  return keys.map(key => places[key])
}

const formattedAddress = (address) => {
  return [
    [address.streetAddress,
      address.addressLocality,
      address.addressRegion].filter(x => x).join(', '),
    // no comma between postal code
    address.postalCode
  ].filter(x => x).join(' ')
}

export class InstantAuditsUsage extends React.Component {
  constructor(props){
    super(props)
  }
  state = {
    isLoading: true,
    initialLoad: true,
    accountId: SessionStore.account.accountId,
    totalItems: 0,
    filters: {
      sortField: 'dateAdded',
      sortOrder: defaultSortOrder,
      offset: 0,
      limit: 20,
      selectedToken: null,
      from: dateRanges[2],
      to: moment(),
    },
    tokens: [],
    hostNames: [],
    usage: []
  }

  toggleBrand = (index) => {
    const updatedUsage = cloneDeep(this.state.usage)
    const item = cloneDeep(this.state.usage[index])
    updatedUsage[index] = {...cloneDeep(item),expanded: !item.expanded}
    this.setState({usage: updatedUsage})
  }

  getColumns = () => ([
    {id:'reportId', title:'Report ID', get: (item) => item.reportId},
    {id:'brandName', title:'Brand Name', get: (item, index) => {
        const places = placesArray(item.places);
        const icon = item.expanded ? 'fa-caret-down' : 'fa-caret-right'
        return <span onClick={() => places.length > 1 && this.toggleBrand(index)} style={places.length > 1 ? {cursor:'pointer'} : {}} >{places.length > 1 && <span className={`pr-2 fas ${icon}`}/>}{places[0].name}</span>
      }},
    {id:'address', title:'Address', get: (item) => {
        const places = placesArray(item.places);
        return places.length === 1 ? formattedAddress(places[0].address) : ''
      }
    },
    {id:'totalLocations', title:'# of Locations',get: (item) => Object.keys(item.places).length},
    {id:'dateAdded', title:'Date', sortable: true, get: (item) => moment(item.report.dateAdded).format("M/D/YYYY")},
    {id:'actions', title:'Actions', actions: [{name:'View Usages', icon: 'usage-action fas fa-external-link-alt fa-lg', disabled: (item) => !item.report.reportLink, onClick: (item) => item.report.reportLink && window.open(item.report.reportLink,'_blank')}]},
  ])

  requestUsageData = () => {
    const {from, to, offset, limit, selectedToken, sortOrder, sortField} = this.state.filters
    this.setState({isLoading: true});
    if(selectedToken) {
      const promises = [
        api.usage([selectedToken.value],[this.state.accountId], from.value.toISOString(), to.toISOString(), limit, offset, sortField, sortOrder),
        api.usageStats([selectedToken.value],[this.state.accountId], from.value.toISOString(), to.toISOString()),
      ];
      axios.all(promises).then( (args) => {
        const usage = args[0].data.result.usage
        const usageStats = args[1].data.result

        this.setState({isLoading: false, initialLoad: false, usage, totalItems: usageStats.reportCount})
      })
    } else {
      this.setState({isLoading: false, initialLoad: false, totalItems: 0})
    }
  }

  initializeRequests = () => {
    const {accountId} = this.state

    api.tokens(accountId).then( resp => {
      let tokens = resp.data.tokens;
      let flatTokens = tokens.flatMap( conf => conf.tokens);
      let filteredTokens = flatTokens.filter(token => !!token).map(token => ({
        label: token.hostname ? `${token.hostname} / ${token.token}` : token.token,
        value: token.token
      }));
      this.setState( state => {
        const filterCopy = cloneDeep(state.filters)
        return {tokens:filteredTokens, filters:{...filterCopy, selectedToken: filteredTokens.length ? filteredTokens[0] : null }}}, this.requestUsageData
      )
    })
  }

  onUpdateFilter = (value) => {
    this.setState( (state) => ({filters:{...state.filters,...value}}),this.requestUsageData)
  }

  setOffset = (newOffset) => {
    this.onUpdateFilter({offset: newOffset})
  }

  onSort = (id) => {
    const getOppositeOrder = (existing) => {
      return existing === 'ASC' ? 'DESC' : 'ASC'
    }
    this.setState( state => {
      const filterCopy = cloneDeep(state.filters)
      const existingSortField = filterCopy.sortField
      const existingSortOrder = filterCopy.sortOrder

      const sortOrder = existingSortField === id ? getOppositeOrder(existingSortOrder) : defaultSortOrder

      this.onUpdateFilter({sortField: id, sortOrder})
    })
  }

  getSortButton = (column) => {
    if (!column.sortable) {
      return ''
    }
    const sortIcon = this.state.filters.sortField !== column.id ? 'fa-sort' : 'fa-sort-' + this.state.filters.sortOrder.toLowerCase()
    return (
      <span className={'clickable fas ' + sortIcon} onClick={() => this.onSort(column.id)}/>
    )
  }


  componentDidMount() {
    this.initializeRequests()
  }

  render() {
    const totalPages = Math.ceil(this.state.totalItems / this.state.filters.limit);
    const currentPage = (totalPages > 0 ? (Math.ceil(this.state.filters.offset / this.state.filters.limit) + 1) : 0);
    const {initialLoad, isLoading, usage, tokens} = this.state
    const columns = this.getColumns();
    const selectComponents = {IndicatorsContainer,DropdownIndicator,IndicatorSeparator};
    return(
      <div className="instant-audits-usage card-spacer-bottom">
        {initialLoad &&
          <div className="text-center">
            <h4 className="admin-update-status">Loading</h4><i className="fas fa-spinner fa-spin fa-2x"></i>
          </div>
        }
        {!initialLoad &&
          <div className="card table-card">
            <div className="card-header">
              <div className="d-flex align-items-center justify-content-between">
                <div className="form-group d-flex align-items-center mb-md-0 ml-md-2">
                  <label className="col-form-label">Site / Token</label>
                  <HelpIcon placement={'top'} message={'Select an API token to view usage'} />
                  <Select
                    styles={reactSelectStyles()}
                    theme={reactSelectTheme}
                    classNamePrefix="r-select"
                    className={'react-select instant-audits-usage__select control-spacer-left'}
                    value={this.state.filters.selectedToken}
                    onChange={(selected) => {
                      this.onUpdateFilter({selectedToken: selected, offset: 0})
                    }}
                    components={selectComponents}
                    options={tokens}
                  />
                </div>
                <div className="form-group d-flex align-items-center mb-0 ml-md-4">
                  <label className="col-form-label">Date Range</label>
                  <HelpIcon placement={'top'} message={'Filter usage results by date range'} />
                  <Select
                    styles={reactSelectStyles()}
                    theme={reactSelectTheme}
                    classNamePrefix="r-select"
                    className={'react-select instant-audits-usage__select control-spacer-left'}
                    value={this.state.filters.from}
                    onChange={(selected) => this.onUpdateFilter({from: selected, offset: 0})}
                    components={selectComponents}
                    options={dateRanges}
                  />
                </div>
              </div>
              <span className="admin-button pull-right"/>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped table-hover table-borderless mb-0">
                  <thead className="table-header">
                    <tr>
                      {columns.map( column => <th key={'column-title-'+column.title}><span>{column.title} {this.getSortButton(column)}</span></th>)}
                    </tr>
                  </thead>
                  <tbody>
                    { !usage.length &&
                      <tr>
                        <td colSpan="6" style={{padding:'40px'}}>
                          <h5 className={'text-center'}>{this.state.tokens.length ? "No Usage Data Found" : "Contact your account manager to get started with Instant Audits"}</h5>
                        </td>
                      </tr>
                    }
                    { usage.length !== 0 && usage.map( (usageRow,index) => {
                      return (
                        <React.Fragment key={'usage-row-'+index}>
                          <tr>
                            {columns.map((column,colIndex) => {
                              return (
                                <td key={'usage-col-'+index+'-'+colIndex}>
                                  {column.id === 'actions' ? <Actions item={usageRow} actions={column.actions}/> :
                                    <span> {column.get(usageRow, index)}</span>}
                                </td>
                              )
                            })}
                          </tr>
                          {usageRow.expanded && placesArray(usageRow.places).map(place => {
                            return (<tr key={place.reportId}>
                              {columns.map(column => <td>{column.id === 'address' && formattedAddress(place.address)}</td>)}

                            </tr>)
                          })
                          }
                        </React.Fragment>
                      )})
                    }
                    { isLoading &&
                      <tr>
                        <td colSpan="6" className="text-center">
                          <i style={{marginLeft: '10px',fontSize: '16px'}} className="fas fa-spinner fa-spin"></i>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer">
              <Pagination
                className="d-flex justify-content-center"
                totalPages={totalPages}
                currentPage={currentPage}
                onChange={(pageNumber) => {
                  this.setOffset((pageNumber - 1)*this.state.filters.limit)
                }}
              />
            </div>
          </div>
        }
      </div>
    )
  }
}

const Actions = (props) => {
  const {item, actions} = props
  return (<div className="btn-group">
    {actions.map( (action,index) => <span key={item.reportId+'-actions-'+index} className={`instant-audits-usage__action ${action.icon} ${action.disabled(item) ? 'instant-audits-usage__action--disabled' : ''}`} onClick={() => action.onClick(item)}/>)}
  </div>)
}





